import { IArticlesData, IArticlesAction } from 'models/magazine/article/articles';
import { IArticleListCard } from 'models/magazine/article/articlelistcard';
import { IStore } from 'redux/IStore';

/** Action Types */
export const REQUEST_SIMILAR_ARTICLES_START: string = 'similararticles/REQUEST_SIMILAR_ARTICLES_START';
export const REQUEST_SIMILAR_ARTICLES_FAILURE: string = 'similararticles/REQUEST_SIMILAR_ARTICLES_FAILURE';
export const GET_SIMILAR_ARTICLES_SUCCESS: string = 'similararticles/GET_SIMILAR_ARTICLES_SUCCESS';

/** Initial State */
const initialState: IArticlesData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	userId: null,
	lastSearchedKeyword: null,
};

/** Reducer */
export function similarArticlesReducer(state = initialState, action: IArticlesAction) {
	switch (action.type) {
		case REQUEST_SIMILAR_ARTICLES_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case REQUEST_SIMILAR_ARTICLES_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_SIMILAR_ARTICLES_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getSimilarArticles(code: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		let queryString: string = '?';
		queryString = queryString + '&currentPage=1';
		queryString = queryString + '&itemsPerPage=3';

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Article/' + code + '/Similar' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(getArticlesSuccess(res.items));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IArticlesAction {
	return {
		type: REQUEST_SIMILAR_ARTICLES_START,
	};
}

/** Action Creator */
export function getArticlesSuccess(items: IArticleListCard[]): IArticlesAction {
	return {
		type: GET_SIMILAR_ARTICLES_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IArticlesAction {
	return {
		type: REQUEST_SIMILAR_ARTICLES_FAILURE,
		payload: {
			message,
		},
	};
}
